import React from 'react';
import { AwardIcon, BanIcon, LeafIcon } from 'lucide-react';
const Expert = () => {
  return <div className="w-full bg-[#DEEFE1] py-10 md:py-16" data-id="element-36">
      <div className="container mx-auto px-4" data-id="element-37">
        <div className="mt-6 text-center" data-id="element-38">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2" data-id="element-39">
            Beneficios que te dan tranquilidad
          </h2>
          <p className="text-lg text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-40">
            Porque lo que cenas tú y tu familia, importa.
          </p>
          <div className="grid grid-cols-3 gap-3 max-w-4xl mx-auto" data-id="element-41">
            <div className="bg-white p-4 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-42">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-[#F0F9F2] rounded-full flex items-center justify-center mb-2" data-id="element-43">
                <AwardIcon className="w-6 h-6 md:w-8 md:h-8 text-[#438A52]" data-id="element-44" />
              </div>
              <h3 className="font-bold text-sm md:text-lg text-gray-800 mb-1" data-id="element-45">
                Certificado por nutrición
              </h3>
              <p className="text-xs md:text-sm text-gray-600" data-id="element-46">
                Revisado por especialistas en nutrición familiar.
              </p>
            </div>
            <div className="bg-[#F0F9F2] p-4 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-47">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-white rounded-full flex items-center justify-center mb-2" data-id="element-48">
                <BanIcon className="w-6 h-6 md:w-8 md:h-8 text-[#438A52]" data-id="element-49" />
              </div>
              <h3 className="font-bold text-sm md:text-lg text-gray-800 mb-1" data-id="element-50">
                Sin conservantes
              </h3>
              <p className="text-xs md:text-sm text-gray-600" data-id="element-51">
                Solo ingredientes reales, como en casa.
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg shadow-md flex flex-col items-center text-center" data-id="element-52">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-[#F0F9F2] rounded-full flex items-center justify-center mb-2" data-id="element-53">
                <LeafIcon className="w-6 h-6 md:w-8 md:h-8 text-[#438A52]" data-id="element-54" />
              </div>
              <h3 className="font-bold text-sm md:text-lg text-gray-800 mb-1" data-id="element-55">
                Ingredientes naturales
              </h3>
              <p className="text-xs md:text-sm text-gray-600" data-id="element-56">
                Recetas limpias, nutritivas y sabrosas.
              </p>
            </div>
          </div>
          <p className="mt-4 md:mt-6 text-base md:text-lg font-medium text-[#438A52] max-w-2xl mx-auto" data-id="element-57">
            Este sistema fue creado pensando en la salud y el bienestar de tu
            familia.
          </p>
        </div>
      </div>
    </div>;
};
export default Expert;